"use client";

import { Dialog } from "@headlessui/react";
import EsimFilters from "./EsimFilters";

export default function EsimFilterDrawer({
  isOpen,
  onClose,
  filters,
  onChange,
  options,
  onReset,
  planType,
  onPlanTypeChange,
  regionalRegions,
}) {
  return (
    <Dialog open={isOpen} onClose={onClose} className="relative z-50 lg:hidden">
      <div className="fixed inset-0 bg-black/30 backdrop-blur-sm" aria-hidden="true" />
      <div className="fixed inset-0 flex justify-end">
        <Dialog.Panel className="w-full max-w-sm bg-background text-textPrimary h-full p-4 overflow-y-auto shadow-xl border-l border-border">
          <div className="flex items-center justify-between mb-4">
            <Dialog.Title className="text-lg font-semibold">eSIM Filters</Dialog.Title>
            <button
              type="button"
              onClick={onClose}
              className="text-xl font-bold text-textSecondary hover:text-accent"
              aria-label="Close filters"
            >
              ×
            </button>
          </div>

          <EsimFilters
            filters={filters}
            options={options}
            onChange={onChange}
            planType={planType}
            onPlanTypeChange={onPlanTypeChange}
            regionalRegions={regionalRegions}
          />

          <div className="mt-4 flex justify-between gap-2">
            <button
              type="button"
              onClick={onReset}
              className="flex-1 py-2 text-sm rounded bg-muted hover:bg-muted/80"
            >
              Reset
            </button>
            <button
              type="button"
              onClick={onClose}
              className="flex-1 py-2 text-sm rounded bg-primary text-white hover:bg-accent"
            >
              Apply
            </button>
          </div>
        </Dialog.Panel>
      </div>
    </Dialog>
  );
}
